import React from "react"

import Button from "Button"
import ItemRow from "./ItemRow"

const TICK_INTERVAL_MS = 5000

// Renders one order's worth of line items as a card. Used by both the live
// kitchen grid (StationView) and the recall screen (RecallPanel) -- the two
// modes differ in which timestamp drives the timer, whether aging colors
// apply, and which action the per-item / per-order buttons trigger.
class OrderCard extends React.Component {
  static defaultProps = {
    actionLabel: "Complete",
    actionAllLabel: "Complete all",
    actionAllColor: "green",
    actionItemTitle: "Tap to complete 1 · Hold to complete all",
    actionItemClassName: "is-success",
    showDismiss: true,
    timerFromField: "kdsFiredAt",
    disableAging: false,
  }

  state = { now: Date.now(), flash: false }

  componentDidMount() {
    this.tick = setInterval(() => this.setState({ now: Date.now() }), TICK_INTERVAL_MS)
    if (this.props.flash) {
      this.setState({ flash: true })
      this.flashTimer = setTimeout(() => this.setState({ flash: false }), 1100)
    }
  }

  componentDidUpdate(prev) {
    if (!prev.flash && this.props.flash) {
      this.setState({ flash: true })
      clearTimeout(this.flashTimer)
      this.flashTimer = setTimeout(() => this.setState({ flash: false }), 1100)
    }
  }

  componentWillUnmount() {
    clearInterval(this.tick)
    clearTimeout(this.flashTimer)
  }

  // Color band: green when under prep target, yellow when 1x-2x, red after 2x.
  agingClass = (referenceAt) => {
    if (this.props.disableAging) return ""
    if (!referenceAt) return ""
    const target = (this.props.prepTimeSeconds || 600) * 1000
    const elapsed = this.state.now - new Date(referenceAt).getTime()
    if (elapsed < target) return ""
    if (elapsed < 2 * target) return "aging-yellow"
    return "aging-red"
  }

  elapsed = (referenceAt) => {
    if (!referenceAt) return ""
    const ms = this.state.now - new Date(referenceAt).getTime()
    const total = Math.max(0, Math.floor(ms / 1000))
    const m = Math.floor(total / 60)
    const s = total % 60
    return `${m}:${s.toString().padStart(2, "0")}`
  }

  // Pick the timestamp that drives the timer. Bump mode tracks "how long has
  // this been firing"; recall mode tracks "how long ago was this bumped".
  referenceAt = (items) => {
    const field = this.props.timerFromField
    return items
      .map((i) => i[field] || (field === "kdsFiredAt" ? i.orderKdsFiredAt : null))
      .filter(Boolean)
      .sort()[0]
  }

  render() {
    const {
      items, onAction, onActionAll, onDismiss,
      actionLabel, actionAllLabel, actionAllColor,
      actionItemTitle, actionItemClassName, showDismiss,
    } = this.props
    if (!items || items.length === 0) return null

    const sample = items[0]
    const referenceAt = this.referenceAt(items)

    const channelClass = (sample.orderChannel || "mobile").replace(/-/g, "_")
    const isTab = sample.orderStatus === "ontab"

    return (
      <div className={`OrderCard ${this.agingClass(referenceAt)} ${this.state.flash ? "flash" : ""}`}>
        <div className="order-header">
          <span className="order-number">#{sample.orderNumber || sample.orderId.slice(0, 6)}</span>
          <span className={`badge ${channelClass}`}>{sample.orderChannel}</span>
          {isTab && <span className="badge tab">Tab</span>}
          <span className="timer">{this.elapsed(referenceAt)}</span>
        </div>
        <div className="item-rows">
          {items.map((item) => (
            <ItemRow
              key={item.id}
              item={item}
              onAction={onAction}
              onActionAll={onActionAll}
              actionLabel={actionLabel}
              actionTitle={actionItemTitle}
              actionClassName={actionItemClassName}
            />
          ))}
        </div>
        <div className="order-actions">
          {showDismiss && <Button color="link" text="Dismiss" onClick={() => onDismiss(items)} />}
          <Button color={actionAllColor} text={actionAllLabel} onClick={() => items.forEach(onActionAll)} />
        </div>
      </div>
    )
  }
}

export default OrderCard
